import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { noop } from 'lodash-es';
import { getPriceStringV2 } from 'site-modules/shared/utils/price-utils';
import { DEFAULT_PRICE } from 'site-modules/shared/components/deal/deal-constants';
import { InfoTooltip } from 'site-modules/shared/components/inventory/info-tooltip/info-tooltip';

export function DealerMsrpPrice({
  advertisedPrice = 0,
  onTooltipOpen = noop,
  priceStrikethrough = false,
  isDealerMsrpAdvertisedPriceSource = false,
  isMsrpFeesIncluded = false,
}) {
  let title = isDealerMsrpAdvertisedPriceSource || !advertisedPrice ? 'MSRP' : 'Dealer price';
  let tooltipText = isDealerMsrpAdvertisedPriceSource
    ? 'This is the retail price of the vehicle, including equipped options.'
    : 'This is the dealer’s advertised price for the vehicle.';

  if (isMsrpFeesIncluded) {
    title = 'Price';
    tooltipText = 'This is the retail price of the vehicle, including equipped options and dealer fees.';
  }

  const handleTooltipOpen = useCallback(() => {
    onTooltipOpen(title);
  }, [onTooltipOpen, title]);

  return (
    <Fragment>
      <div className="mb-0 fw-normal text-gray-darker" style={{ lineHeight: '1rem', fontSize: '0.75rem' }}>
        {title}
        <InfoTooltip
          id="dealer-price-tooltip"
          className="top-0"
          item={{
            text: tooltipText,
            placement: 'bottom',
          }}
          onTooltipOpen={handleTooltipOpen}
          screenReaderTooltipLabel={title}
        />
      </div>
      <div className="heading-2 mb-0">
        {advertisedPrice ? (
          <span
            className={classNames({
              'price-strike': priceStrikethrough,
            })}
            data-testid="vdp-price"
            data-test="vdp-price-row"
          >
            {getPriceStringV2(advertisedPrice)}
          </span>
        ) : (
          <span className="fw-normal">{DEFAULT_PRICE}</span>
        )}
      </div>
    </Fragment>
  );
}

DealerMsrpPrice.propTypes = {
  advertisedPrice: PropTypes.number,
  onTooltipOpen: PropTypes.func,
  priceStrikethrough: PropTypes.bool,
  isMsrpFeesIncluded: PropTypes.bool,
  isDealerMsrpAdvertisedPriceSource: PropTypes.bool,
};
